import { getMessaging, getToken, onMessage, isSupported, Messaging } from "@firebase/messaging";
import { getFirebaseAuth, firebaseConfig, events, getState } from './firebase';
import { updateUserNotificationToken } from "@roc-digital/mxm-base/logic";
import { CommentNotificationData } from "@roc-digital/types";
import { logEvent } from "./analytics";

const key = firebaseConfig.vapidKey;

let messagingInstance: Messaging | null = null;

async function getMessagingIfSupported() {
  if (messagingInstance) return messagingInstance;

  const supported = await isSupported();
  if (!supported) return null;

  messagingInstance = getMessaging();
  return messagingInstance;
}

function setupOnMessage(messaging: Messaging) {
  onMessage(messaging, (message) => {
    const notification = new Notification(message.notification?.title || '', {
      body: message.notification?.body || '',
      image: message.data?.image_url,
      icon: message.data?.image_url,
    });

    notification.onclick = () => {
      if(message.data?._type === 'article') {
        const data = message.data;

        try {
          logEvent('open_notification', {
            articleId: data?.id || data?.article_id,
            notification: data?.['_type'],
            title: data?.content || data?.title,
          });
        } catch(err) {
          console.error(err);
        }

        window.location = `/article/${message.data.slug || message.data.id}` as any;
      } else if(message.data?._type === 'comment') {
        let data = message.data as any as CommentNotificationData;
        window.location = `/article/${data.article_id}?comment_id=${data.comment_id}&reply_id=${data.reply_to}` as any;
      }
    }
  });
}

export function initNotifications() {
  getMessagingIfSupported().then((messaging) => {
    if (messaging) {
      setupOnMessage(messaging);
    }
  }).catch(e => console.error(e));

  const update = () => {
    const state = getState();
    if(state.authenticated) {
      checkNotificationsStatus().catch(e => console.error(e))
    }
  }

  update();
  events.addEventListener('next', update);
}

export async function getPushToken() {
  const messaging = await getMessagingIfSupported();
  if (!messaging) return '';

  const permissions = Notification.permission;
  if(permissions !== 'denied') {
    return await getToken(messaging, {vapidKey: key});
  }

  return '';
}

export async function sendToken(token: string) {
  await updateUserNotificationToken(token);
}

let tryCount = 0;
export async function checkNotificationsStatus() {
  try {
    const token = await getPushToken();
    if(!token) {
      const permission = await Notification.requestPermission();

      if(permission !== "denied" && tryCount < 3) {
        tryCount++
        await checkNotificationsStatus();
      }

      return;
    }

    await sendToken(token);

  } catch(err) {
    console.error(err);
  }
}

// function safeJsonParse<T>(json: string, defaultValue: T): T {
//   try {
//     if(!json) return defaultValue;
//     const value = JSON.parse(json);
//     if(value === null || value == undefined) {
//       return defaultValue;
//     }

//     return value;

//   } catch(err) {
//     console.error(err);
//     return defaultValue;
//   }
// }